import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { formatMoney } from '../../../../utils/utils';
import QueryGuard from '../../../../Components/QueryGuard';
import Table from '../../../../Components/Table';
import { GET_GIFT_CARDS } from '../../../GiftVouchers/graphql/queries';
import { GiftCardType } from '../../../GiftVouchers/type';
import { useNavigate } from 'react-router-dom';

interface Props {
  customerId: string;
}

const CustomerTickets: FC<Props> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, error, loading } = useQuery(GET_GIFT_CARDS, { variables: { customerId } });

  const renderTicketTable = (giftVoucher: GiftCardType[]) => {
    const tableData = giftVoucher.map((giftVoucher) => ({
      data: {
        code: giftVoucher.code,
        amount: formatMoney(giftVoucher.amount || 0)
      },
      onRowClick: () => navigate(`/gift-vouchers/${giftVoucher.id}`)
    }));

    return <Table tableData={tableData} />;
  };

  return (
    <QueryGuard data={data && data.giftCards} loading={loading} error={error ? !!error : false} displayNoResult={false}>
      {data && data.giftCards && (
        <div>
          <h2 className="text-lg font-bold my-4">Gift vouchers</h2>
          <div>{renderTicketTable(data.giftCards)}</div>
        </div>
      )}
    </QueryGuard>
  );
};

export default CustomerTickets;
